import { render, staticRenderFns } from "./NotificationsSetting.vue?vue&type=template&id=53b729d3&scoped=true&"
import script from "./NotificationsSetting.vue?vue&type=script&lang=js&"
export * from "./NotificationsSetting.vue?vue&type=script&lang=js&"
import style0 from "./NotificationsSetting.vue?vue&type=style&index=0&id=53b729d3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53b729d3",
  null
  
)

export default component.exports